import request from "@/utils/request";

//用户优惠劵
export function queryShopCouponList(params) {
  return request({
    url: "/api/system/shopCoupon/getShopCouponId",
    method: "post",
    data: params
  });
}
//系统优惠劵中心
export function getSysCounponIsGet(params) {
  return request({
    url: "/api/system/sysCoupon/couponCenter",
    method: "post",
    data: params
  });
}
//领取优惠劵
export function saveShopCoupon(params) {
  return request({
    url: "/api/system/shopCoupon/saveShopCoupon",
    method: "post",
    data: params
  });
}
// 用户我的优惠劵中心
export function myCoupon(params) {
  return request({
    url: "/api/system/shopCoupon/myCoupon",
    method: "post",
    data: params
  });
}
//优惠劵使用记录
export function useRecord(params) {
  return request({
    url: "/api/system/shopCoupon/useRecord",
    method: "post",
    data: params
  });
}
//可使用的优惠劵
export function usableCoupon(params) {
  return request({
    url: "/api/system/shopCoupon/usableCoupon",
    method: "post",
    data: params
  });
}

//可使用的优惠劵
export function getGiftInfo(params) {
  return request({
    url: "/api/system/sysCoupon/getGiftInfo",
    method: "post",
    data: params
  });
}



// WEBPACK FOOTER //
// ./src/api/coupon/index.js